import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AllowedOsUpdatesStoreActions } from './index';

import { DevicesRouterStoreSelectors } from '@era/stores';

@Injectable({ providedIn: 'root' })
export class DeviceAllowedOsUpdatesResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((deviceId) => {
        if (!deviceId) {
          return;
        }

        this.store.dispatch(
          AllowedOsUpdatesStoreActions.AllowedOsUpdatesResolverActions.allowedUpdatesRequested({
            deviceId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
